// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.live-open-positions-content {
  padding: 24px;
  max-width: 1100px;
  margin: 0 auto;
}

.live-open-positions-banner {
  background: #eef4ff;
  border: 1px solid #c9dcff;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.5;
  color: #26314f;
}

.live-open-positions-refreshed {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #5a6785;
}

.live-open-positions-status {
  padding: 16px;
  color: #5a6785;
  font-size: 14px;
}

.live-open-positions-error {
  color: #b3261e;
}

.live-open-positions-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.live-open-positions-table th,
.live-open-positions-table td {
  text-align: left;
  padding: 8px 12px;
  border-bottom: 1px solid #e5e9f2;
}

.live-open-positions-table th {
  font-weight: 600;
  color: #38415c;
  background: #f7f9fc;
}

.live-row-stale {
  opacity: 0.6;
}

.live-row-stale-badge {
  margin-left: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #b3261e;
  background: #fbe7e6;
  border-radius: 4px;
  padding: 1px 6px;
}
`, "",{"version":3,"sources":["webpack://./src/LiveOpenPositions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".live-open-positions-content {\n  padding: 24px;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.live-open-positions-banner {\n  background: #eef4ff;\n  border: 1px solid #c9dcff;\n  border-radius: 8px;\n  padding: 14px 16px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #26314f;\n}\n\n.live-open-positions-refreshed {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  color: #5a6785;\n}\n\n.live-open-positions-status {\n  padding: 16px;\n  color: #5a6785;\n  font-size: 14px;\n}\n\n.live-open-positions-error {\n  color: #b3261e;\n}\n\n.live-open-positions-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.live-open-positions-table th,\n.live-open-positions-table td {\n  text-align: left;\n  padding: 8px 12px;\n  border-bottom: 1px solid #e5e9f2;\n}\n\n.live-open-positions-table th {\n  font-weight: 600;\n  color: #38415c;\n  background: #f7f9fc;\n}\n\n.live-row-stale {\n  opacity: 0.6;\n}\n\n.live-row-stale-badge {\n  margin-left: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #b3261e;\n  background: #fbe7e6;\n  border-radius: 4px;\n  padding: 1px 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
